<div class="list-wrapper">
  <kgrid
    #grid
    *ngIf="columns && columns.length > 0"
    [apiName]="apiName"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    [paging]="true"
    reportName="SubLedger"
    pathPreFix="ACC"
    [columns]="columns"
    [isMulti]="false"
    [actions]="actions"
    [actionTregger]="onActionClick"
    [customExportExcelUrl]="'SubLedger/ExportExcel'"
    [inputEditorform]="inputEditorform"
    [getParamsForExportExcelWithPostMethod]="getParamsForExportExcelWithPostMethod.bind(this)">
  </kgrid>
</div>
